module.exports = {"id":"225309","name":"Nadiem Amiri","rating":"78","photo":"./data/images/photos/2/225309.png","club":{"name":"1899 Hoffenheim","logo":"./data/images/clubs/1899Hoffenheim.png"},"positions":["MOC","MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NadiemAmiri0.json
// module id = 3123
// module chunks = 0